import * as React from 'react';
import { useSelector } from 'react-redux';
import { lookupsLoadingFinishedSelector } from 'store/lookups/selector';
import { useHistory, useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { Fabric, Pivot, PivotItem } from '@fluentui/react';
import { mergeStyleSets } from '@fluentui/react/lib/Styling';
import { LagerstandView } from 'reports/lagerstand/LagerstandView';
import { authSelector } from 'store/auth/selector';
import { ArtikelView } from './ArtikelView/ArtikelView';

const styles = mergeStyleSets({
    container: {
        width: '100%',
        height: '100%',
    },
    itemWrapper: {
        height: 'calc(100vh - 75px)',
    },
});

const pivotStyles = {
    itemContainer: {
        height: 'calc(100vh - 120px)',
    },
};

interface LagerViewParams {
    page?: string;
}

export const LagerView: React.FC = () => {
    const auth = useSelector(authSelector);
    const lookupsLoadingFinished = useSelector(lookupsLoadingFinishedSelector);
    const history = useHistory();
    const { page } = useParams<LagerViewParams>();

    if (!page) {
        history.push('/lager/artikel');
    }

    if (!lookupsLoadingFinished) {
        return null;
    }

    return (
        <Fabric className={styles.container}>
            <Helmet>
                <title>Lager</title>
            </Helmet>
            <Pivot
                styles={pivotStyles}
                selectedKey={page || 'artikel'}
                onLinkClick={(item) => {
                    history.push('/lager/' + (item?.props.itemKey || ''));
                }}
            >
                {(auth.rolle === 'ID' || auth.rolle === 'GF' || auth.rolle === 'EX') && (
                    <PivotItem itemKey="artikel" headerText="Artikel" className={styles.itemWrapper}>
                        <ArtikelView />
                    </PivotItem>
                )}

                <PivotItem itemKey="lagerstand" headerText="Lagerstand" className={styles.itemWrapper}>
                    <LagerstandView />
                </PivotItem>

                {/*
                <PivotItem itemKey="lagerartikel" headerText="Lagerartikel" className={styles.itemWrapper}>
                    <ArtikelDetailView />
                </PivotItem>
                */}
            </Pivot>
        </Fabric>
    );
};
